import { useRecoilValue } from "recoil";
import { authState } from "../../recoil/authState";
import { 
  CalendarToday, 
  CalendarMonth, 
  LocalOffer, 
  AccessTime, 
  SportsGolf,
  Event,
  Home,
  Business,
} from "@mui/icons-material";
import { checkAuthLevel, createConditionalMenuItems } from "./utils";

export default function useNavData() {
  const auth = useRecoilValue(authState);
  const clubAdminLevel = auth?.user?.club_admin_level;
  const isMaster = checkAuthLevel.isMaster(clubAdminLevel);
  const isNotSBS = checkAuthLevel.isNotSBS(clubAdminLevel);
  const clubId = auth?.user?.club_id;

  const navData = [
    {
      key: "home",
      name: "홈",
      icon: <Home />,
      isTopParent: true,
      child: [
        {
          key: "dashboard",
          name: "대시보드",
          path: "home",
          isMenuItem: true,
          child: [],
        },
      ],
    },
    {
      key: "yb",
      name: "연 단체 예약",
      icon: <CalendarToday />,
      isTopParent: true,
      child: [
        {
          key: "yearBookingList",
          isMenuItem: true,
          name: "신청내역",
          child: [{ key: ":id", name: "신청상세" }],
        },
        {
          key: "yearBookingRoundingList",
          isMenuItem: true,
          name: "예약내역",
          child: [{ key: ":id", name: "예약상세" }],
        },
        // SBS가 아닐 때 단체관리 표시
        ...createConditionalMenuItems(isNotSBS, [
          {
            key: "yearBookingGroups",
            isMenuItem: true,
            name: "단체관리",
            child: [{ key: ":id", name: "단체상세" }],
          },
        ]),
      ],
    },
    // SBS일 때는 월단체 부킹 숨김
    ...createConditionalMenuItems(isNotSBS, [
      {
        key: "eb",
        name: "월 단체 예약",
        icon: <CalendarMonth />,
        isTopParent: true,
        child: [
          {
            key: "eventBookingList",
            isMenuItem: true,
            name: "신청내역",
            child: [{ key: ":id", name: "신청상세" }],
          },
          {
            key: "eventBookingRoundingList",
            isMenuItem: true,
            name: "예약내역",
            child: [{ key: ":id", name: "예약상세" }],
          },
        ],
      },
    ]),
    // 할인 부킹 표시
    {
      key: "dc",
      isTopParent: true,
      name: "할인 예약",
      icon: <LocalOffer />,
      child: [
        {
          key: "bookingdiscountList",
          name: "할인부킹 관리",
          isMenuItem: true,
          child: [
            {
              key: "create",
              name: "할인부킹 등록",
              child: [{ key: ":id", name: "상세" }],
            },
          ],
        },
        {
          key: "bookingdiscountrsvps",
          name: "할인부킹 예약 관리",
          isMenuItem: true,
          child: [],
        },
      ],
    },
    {
      key: "erp",
      isTopParent: true,
      name: "실시간 예약",
      icon: <AccessTime />,
      child: [
        {
          key: "erpBookingList",
          name: "예약내역",
          isMenuItem: true,
          child: [{ key: ":id", name: "예약상세" }],
        },
      ],
    },
    {
      key: "event",
      isTopParent: true,
      name: "이벤트",
      icon: <Event />,
      child: [
        {
          key: "eventList",
          name: "이벤트 관리",
          path: "common/golfinfo/event",
          isMenuItem: true,
          child: [
            { key: "create", name: "이벤트 등록" },
            { key: ":id", name: "이벤트 상세" },
          ],
        },
      ],
    },
    // SBS일 때는 골프장 서비스 숨김
    ...createConditionalMenuItems(isNotSBS, [
      {
        key: "golfservice",
        name: "골프장 서비스",
        icon: <SportsGolf />,
        isTopParent: true,
        child: [
          {
            key: "golfinfo",
            name: "골프장 관리",
            // CEO 계정은 목록 페이지로, 일반 계정은 바로 수정 페이지로
            path: isMaster ? "common/golfinfo" : (clubId ? `common/golfinfo/modify/${clubId}` : "common/golfinfo"),
            child: [
              {
                key: "modify",
                name: "정보 수정",
                path: "common/golfinfo/modify",
                child: [{ key: ":id", name: "골프장 정보" }],
              },
            ],
            isMenuItem: true,
          },
          {
            key: "golfacount",
            name: "골프장 계정관리",
            path: "common/golfacount",
            child: [],
            isMenuItem: true,
          },
          // CEO 계정(레벨 10)만 타임라인 메뉴 표시
          ...createConditionalMenuItems(isMaster, [
            {
              key: "timeline",
              name: "타임라인",
              path: "analytics/timeline",
              child: [],
              isMenuItem: true,
            },
          ]),
        ],
      },
    ]),
    // CEO 계정(레벨 10)만 ERP 신청 리스트 메뉴 표시
    ...createConditionalMenuItems(isMaster, [
      {
        key: "erprequest",
        name: "ERP 관리",
        icon: <Business />,
        isTopParent: true,
        child: [
          {
            key: "erpRequestList",
            name: "ERP 신청 리스트",
            path: "erp/erpRequestList",
            child: [],
            isMenuItem: true,
          },
        ],
      },
    ]),
  ];

  return navData;
}
